<script setup lang="ts">
defineProps<{
  items: { label: string; to?: string }[]
}>()
</script>

<template>
  <nav class="breadcrumb" aria-label="Breadcrumb">
    <template v-for="(item, index) of items" :key="index">
      <span v-if="index > 0" class="separator" aria-hidden="true">/</span>
      <NuxtLink v-if="item.to" :to="item.to">{{ item.label }}</NuxtLink>
      <span v-else aria-current="page">{{ item.label }}</span>
    </template>
  </nav>
</template>

<style lang="scss" scoped>
.breadcrumb {
  display: flex;
  gap: 8px;
  color: var(--text-subtle);
  font-size: 0.85em;
  margin-bottom: 25px;

  a {
    color: var(--text);
    text-decoration: none;
    font-weight: bold;

    &:hover {
      color: var(--primary);
    }
  }
}
</style>
